import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import NoSsr from "@material-ui/core/NoSsr";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import { grey } from "@material-ui/core/colors";

import Following from "./Following";

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 0, marginTop: 0 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired
};

function LinkTab(props) {
  return (
    <Tab
      component={"button"}
      onClick={event => event.preventDefault()}
      {...props}
    />
  );
}

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    margin: "0 0"
  },
  tabsRoot: {
    backgroundColor: grey[700]
  },
  tabRoot: {
    fontWeight: theme.typography.fontWeightBold
  },

  tabsIndicator: {
    borderBottom: "4px solid #ff5722",
    backgroundColor: "#ff5722"
  },
  "&$tabSelected": {
    color: grey[50],
    fontWeight: theme.typography.fontWeightMedium
  },
  tabSelected: {
    color: grey[50],
    fontWeight: theme.typography.fontWeightMedium,
    backgroundColor: "#ff5722"
  },
  topBarStyle: {
    borderBottom: "6px solid #ff5722"
  }
});

class ViewFollowing extends React.Component {
  state = {
    value: 0,
    option: "followers"
  };

  handleChange = (event, value) => {
    this.setState({ value, option: value === 0 ? "followers" : "following" });
  };

  componentDidMount() {
    this.setState({
      value: this.props.option === "followers" ? 0 : 1,
      option: this.props.option
    });
  }

  FollowingTabs = ({ classes }) => (
    <AppBar position="sticky">
      <Tabs
        variant="fullWidth"
        value={this.state.value}
        onChange={this.handleChange}
        classes={{
          root: classes.tabsRoot,
          indicator: classes.tabsIndicator
        }}
      >
        <LinkTab
          classes={{
            root: classes.tabRoot,
            selected: classes.tabSelected
          }}
          label="Posts"
          onClick={() => {}}
        />
        <LinkTab
          classes={{
            root: classes.tabRoot,
            selected: classes.tabSelected
          }}
          label="My LFP"
          onClick={() => {}}
        />
      </Tabs>
    </AppBar>
  );

  followTabs = ({ classes }) => (
    <AppBar position="sticky" className={classes.topBarStyle}>
      <Tabs
        variant="fullWidth"
        value={this.state.value}
        onChange={this.handleChange}
        classes={{
          root: classes.tabsRoot,
          indicator: classes.tabsIndicator
        }}
      >
        <LinkTab
          classes={{
            root: classes.tabRoot,
            selected: classes.tabSelected
          }}
          label="Followers"
        />
        <LinkTab
          classes={{
            root: classes.tabRoot,
            selected: classes.tabSelected
          }}
          label="Following"
        />
      </Tabs>
    </AppBar>
  );
  render() {
    const { classes, option } = this.props;
    const { value } = this.state;

    return (
      <NoSsr>
        <div className={classes.root}>
          {this.followTabs({ ...this.props })}
          {value === 0 && (
            <TabContainer style={{ padding: "4px 8px" }}>
              <Following option={this.state.option} />
            </TabContainer>
          )}
          {value === 1 && (
            <TabContainer>
              <Following option={this.state.option} />
            </TabContainer>
          )}
        </div>
      </NoSsr>
    );
  }
}

ViewFollowing.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ViewFollowing);
